import * as React from 'react'
import { useRegistrationContext } from '../context/registration'
import { RouteProps } from './Route.types'

export const Route = ({ path, component }: RouteProps) => {
  const { route } = useRegistrationContext()

  if (route !== path) {
    return null
  }

  return <>{component}</>
}
